import React, { useEffect, useState } from 'react'
import DateRange from '../../Component/DateRange/DateRange';
import { Table } from '../../Component/Table/Table';
import { admin_list } from '../redux/api/dummyJson';
import ScreenPagination from '../../Component/ScreenPagination/ScreenPagination';
import { useLocation } from 'react-router-dom';
import { FullTable } from '../../Component/Table/FullTable';
import { URLS } from '../../Services/Constant';
import { get } from '../../Services/ApiHandler';

const WinningReport = () => {
    const [pagenumber, setPagenumber] = useState(1);
    const [pagination, setPagination] = useState("");
    const [page, setPage] = useState(1);

    const location = useLocation();
    const listData = location.state?.listData;
    const reportName = location.state?.reportName;
    const slotId = location.state?.slotId;
    // // console.log("listData", listData);

    const [listingData, setListingData] = useState(listData || []);

    const fetchWinningReport = async () => {
        const res = await get(`${URLS.REPORTLIST}/${reportName}?game_slot_id[]=${slotId}`);
        // // console.log("res report", res);
        setListingData(res || []);
    }

    useEffect(() => {
        fetchWinningReport();
    }, [listData]);



    const columns = React.useMemo(
        () => [
            {
                Header: "Date",
                accessor: "date",
                 minWidth: 180,
                Cell: ({ value, row }) => {
                    return <p className="text-nowrap" >{value}</p>;
                },
            },
            // {
            //     Header: " Time",
            //     accessor: "time",
            //     Cell: ({ value, row }) => {
            //         return <p className="text-nowrap">{value}</p>;
            //     },
            // },

            {
                Header: "Lot Details",
                accessor: "lot_details",
                Cell: ({ value }) => {
                    const text = value || "";

                    const lower = text.toLowerCase();
                    let index = -1;

                    if (lower.includes("dear")) {
                        index = lower.indexOf("dear");
                    } else if (lower.includes("kerala")) {
                        index = lower.indexOf("kerala");
                    }

                    let firstLine = text;
                    let secondLine = "";

                    if (index !== -1) {
                        firstLine = text.substring(0, index).trim();
                        secondLine = text.substring(index).trim();
                    }

                    return (
                        <div>
                            <p>{firstLine}</p>
                            {secondLine && <p>{secondLine}</p>}
                        </div>
                    );
                },
            },
            {
                Header: "Prize Details",
                accessor: "price_detail",
                Cell: ({ value, row }) => {
                    return <div>
                        <p className="" >{value}</p>
                        {/* <p className="" >{value?.message?.time}</p> */}
                    </div>
                },
            },
            {
                Header: "Prize Number",
                accessor: "my_number",
                Cell: ({ value, row }) => {
                    return <p className="text-nowrap">{value}</p>;
                },
            },
            {
                Header: "Qty",
                accessor: "qty",
                Cell: ({ value, row }) => {
                    return <p className="text-nowrap">{value}</p>;
                },
            },
            {
                Header: "Prize",
                accessor: "price",
                Cell: ({ value, row }) => {
                    return <div>
                        {/* <span> ₹ </span> */}
                        <p className="text-nowrap">{value}</p>
                    </div>
                },
            },

            {
                Header: "Paid Status",
                accessor: "paid_status",
                Cell: ({ value, row }) => {
                    return <div className='d-flex ac-jc'>
                        <p className={`${value == "Not Paid" ? "err-btn" : "appr-btn"}`}>{value}</p>
                    </div>
                },
            },


        ],
        []
    );



    return (
        <div className='dashRightView p-0 pb-2 pt-3'>

            <FullTable
                columns={columns}
                setPageno={setPage}
                pagecount={pagination}
                // tableHeight={"75vh"}
                data={listingData?.data || []}
                show={false}
            />
            <div className="screen-pagination">
                <div
                    className="d-flex ac-jb bg-primary1 white p-2 px-3"
                    style={{ marginBottom: 3 }}
                >
                    <p className="f3 fs-xs-14 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22">
                        Total Prize
                    </p>
                    <p className="f3 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24">
                        ₹ {listingData?.total_amount}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default WinningReport